import { render, staticRenderFns } from "./SpecialOffers.vue?vue&type=template&id=f90972b4&scoped=true&"
import script from "./SpecialOffers.vue?vue&type=script&lang=js&"
export * from "./SpecialOffers.vue?vue&type=script&lang=js&"
import style0 from "./SpecialOffers.vue?vue&type=style&index=0&id=f90972b4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90972b4",
  null
  
)

export default component.exports